import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  IconButton,
  alpha
} from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import ReadableText from '../../../../components/text/ReadableText';

const TranslationResults = ({ translationResult, onCopy }) => {
  const theme = useTheme();

  if (!translationResult) return null;

  return (
    <Box sx={{ mt: 4 }} className="card-fade-in">
      <Divider sx={{ mb: 3, borderColor: alpha(theme.palette.common.white, 0.1) }} />
      
      <Typography variant="h6" gutterBottom>
        Translation Results
      </Typography>

      <Card 
        variant="outlined" 
        sx={{ 
          mb: 3, 
          bgcolor: theme.palette.background.paper,
          borderColor: alpha(theme.palette.common.white, 0.1)
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle2" color="primary">
              Original Text
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => onCopy(translationResult.originalText)}
              sx={{ color: theme.palette.text.secondary }}
            >
              <CopyIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography variant="body1" paragraph>
            {translationResult.originalText}
          </Typography>

          <Divider sx={{ my: 2, borderColor: alpha(theme.palette.common.white, 0.1) }} />
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle2" color="primary">
              Readable English Translation
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => onCopy(translationResult.translatedText)}
              sx={{ color: theme.palette.text.secondary }}
            >
              <CopyIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ 
            p: 2, 
            bgcolor: alpha(theme.palette.primary.main, 0.05),
            borderRadius: 1,
            border: '1px solid',
            borderColor: alpha(theme.palette.primary.main, 0.2)
          }}>
            <ReadableText text={translationResult.translatedText} />
          </Box>
          
          {translationResult.homophones && translationResult.homophones.length > 0 && (
            <>
              <Divider sx={{ my: 2, borderColor: alpha(theme.palette.common.white, 0.1) }} />
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Homophones
              </Typography>
              <Box sx={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: 1,
                p: 2,
                bgcolor: alpha(theme.palette.background.paper, 0.4),
                borderRadius: 1 
              }}>
                {translationResult.homophones.map((group, groupIndex) => (
                  <Box key={groupIndex} sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    border: '1px solid',
                    borderColor: alpha(theme.palette.info.main, 0.3),
                    borderRadius: 1,
                    p: 0.5,
                    bgcolor: alpha(theme.palette.info.main, 0.05)
                  }}>
                    {group.map((word, wordIndex) => (
                      <React.Fragment key={wordIndex}>
                        <Typography variant="body2" color="text.primary">
                          {word}
                        </Typography>
                        {wordIndex < group.length - 1 && (
                          <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
                            |
                          </Typography>
                        )}
                      </React.Fragment>
                    ))}
                  </Box>
                ))}
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default TranslationResults;